import {
    useImperativeHandle,
    forwardRef,
    useState,
    useContext
} from 'react'
import { createPortal } from 'react-dom'
import styles from './index.module.scss'
import { AppContext } from '@utils/AppContext'
import Iconfont from '@utils/Iconfont';

const TopEventPopup = forwardRef((props, ref) => {
    const { daysMessage, setDaysMessage } = useContext(AppContext)

    const [open, setOpen] = useState(false)
    const [popupData, setPopupData] = useState(null)
    const [callback, setCallback] = useState(() => { })

    useImperativeHandle(ref, () => ({
        handleClick
    }))

    const handleClick = (popup, onClose) => {
        if (daysMessage) return
        setPopupData(popup)
        setCallback(() => onClose)
        setOpen(true)
        document.documentElement.style.setProperty('--header-height', '50px')
    }

    const cancleClick = () => {
        callback?.()
        const html = document.querySelector('html')
        html.style.setProperty('--header-height', '0px');
        setOpen(false)
    }

    const mainBox = document.getElementById('mainBox')

    if (!open || !mainBox) return null

    return createPortal(
        <div
            className={styles.topEventPopup}
            onClick={() => { props.popupClick(popupData); cancleClick() }}
            style={{
                height: 'var(--header-height)',
                background: `url(${popupData?.popupImage}) center / cover no-repeat`,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                fontSize: '14px',
                transition: 'all 0.3s ease-in-out',
                cursor: 'pointer'
            }}
        >
            <Iconfont className={styles.Icon} onClick={() => { cancleClick() }} type="icon-general_close" />
        </div>,
        mainBox
    )
})

export default TopEventPopup
